<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li :class="{'tab-menu__item': true, 'active': mode == 'getDepartment'}" @click="switchView('getDepartment')"><a href="javascript:;">Clinic Introduction</a></li>
            <li :class="{'tab-menu__item': true, 'active': mode == 'getDoctorList'}" @click="switchView('getDoctorList')"><a href="javascript:;">Medical Staff</a></li>
        </ul>
    </div>
    <div class="about" v-if="mode == 'getDepartment'">
        <div class="about__img">
            <swiper :pagination="true"  :modules="modules" :effect="'fade'" :autoplay="{ delay: 4000 }" :speed="500" class="subSwiper">
                <swiper-slide v-if="org">
                    <img :src="`/displayFile.do?attachNo=${org[0].attachNo}`" :alt="org[0].altValue || '이미지'" >
                </swiper-slide>
            </swiper>
            <p class="about__line-text"></p>
        </div>
        <div class="about__text">
            <p class="about__desc" v-html="contents"></p>
        </div>
    </div>

    <div class="contents" v-if="mode == 'getDoctorList'">
        <en_DoctorCard :doctorList="doctorList"/>
    </div>

    <en_QuickMenu :info="info"/>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay, EffectFade } from 'swiper/modules';

export default{
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Mousewheel, Keyboard, Autoplay, EffectFade],
        };
    },
    data() {
        return {
            mode: 'getDoctorList',
            deptCd: this.$route.query.deptCd || '',
            // 클리닉
            info: '',
            contents: '',
            // 의료진
            doctorList: [],
            // 위치안내
            location: [],
            floor: '',
            // 단체이미지
            org: '',
        }
    },
    methods: {
        switchView(mode){
            this.mode = mode
            // this[mode]()
        },
        getDepartment(){
            const param = {
                hospId: this.$store.getters.getHost,
                deptCd: this.deptCd,
                langCd: this.$store.getters.getLang
            }
            this.axios.get(this.api.department.view, {params: param})
            .then(res => {
                this.info = res.data
                this.org = this.info?.orgAttach?.organizationImg
                this.contents = ''
                this.contents = res.data.deptInfoGlb + '<br><br>'
                if(res.data?.deptDetailList?.length > 0) this.contents += res.data.deptDetailList[0].contents
            })
        },
        getDoctorList(){
            const param = {
                startIndex: 1,
                pageRow: 999,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                deptCd: this.deptCd,
                orderType: 'deptSort',
                // deptType: 1
            }
            this.axios.get(this.api.doctor.doctorList, {params: param})
            .then(res => {
                if(res.data.doctorTotCnt > 0){
                    this.doctorList = res.data.doctorList
                }
            })
        },
        getLocation(){
            const param = {
                deptCd: this.deptCd
            }
            this.axios.get(this.api.lookAround.deptLookAround, {params: param})
            .then(res => {
                this.location = []
                if(res.data?.length > 0) {
                    const list = res.data
                    for(let i of list){
                        if(i.parentPlaceNm == '본관'){
                            this.location.push(i)
                        }
                    }
                    this.floor = res.data[0].floor.replace('F', '층')
                    
                    const floorSort = (floor) => {
                        if (floor.startsWith('B')) {
                            return -parseInt(floor.substring(1))
                        }
                        if (floor.startsWith('F')) {
                            return parseInt(floor.substring(1))
                        }
                        return 0
                    }

                    this.location.sort(function(a, b) {
                        return floorSort(a.floor) - floorSort(b.floor);
                    })
                }
            })
        }
    },
    mounted() {
        if(!this.deptCd){
            alert("잘못된 접근입니다.")
            this.$router.push('/')
            return
        }
        
        this.getDepartment()
        this.getDoctorList()
    },
    watch: {
        $route(to, from){
            if(to.path == from.path){
                this.mode = 'getDoctorList'
                this.deptCd = to.query.deptCd,
                this.getDepartment()
                this.getDoctorList()
            }
        }
    },
}
</script>